import BaseService from './BaseService';

export default class FeedbackService extends BaseService {
  public async sendFeedback(feedback?: string, rating?: number): Promise<void> {
    const response = await this.client.post('/feedback', { feedback, rating });
    return response.data;
  }
}
